import { breadcrumbsIntegration, captureException, init } from '@sentry/vue';
import Vue from 'vue';
export default defineNuxtPlugin(function (_ref) {
  var hook = _ref.hook;
  var _useRuntimeConfig$pub = useRuntimeConfig().public.sentry,
    dsn = _useRuntimeConfig$pub.dsn,
    environment = _useRuntimeConfig$pub.environment;
  init({
    Vue: Vue,
    dsn: dsn,
    environment: environment,
    release: process.env.SENTRY_RELEASE,
    sendDefaultPii: false,
    autoSessionTracking: false,
    integrations: [breadcrumbsIntegration({
      dom: false
    })]
  });
  hook('app:error', function (err) {
    captureException(err);
  });
});